import { TCommonData, TextInputEnum, TWidget } from '@libs/types';
import * as React from 'react';
import { getWidgetById as getWidgetByIdWidgets } from './widgets';
import { getCoreWidgetById } from '@core/widgets';
import type { WidgetEnum } from '../types/enums';

export const getWidgetById = (widgetId: WidgetEnum & TextInputEnum, widget: TWidget<TCommonData>, Package: React.ElementType) => {
    const widgetById = getWidgetByIdWidgets(widgetId, widget, Package);
    if (widgetById) {
        return widgetById;
    } else {
        return getCoreWidgetById(widgetId, widget, Package);
    }
};
